export default __webpack_public_path__ + "static/media/banner-img.a7e9d444.png";